<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="mv-mitglieder">
            <h2>
                Mitglieder
                <b-button
                    v-b-toggle.mitgliederFilterCollapse
                    variant="outline-secondary"
                    :pressed="filterShown"
                    size="sm"
                >{{ toggleBtnText }}</b-button>
            </h2>
            <b-collapse id="mitgliederFilterCollapse" v-model="filterShown">
                <b-row>
                    <b-col lg="8">
                        <MitgliederFilter @submitFilter="submitFilter" />
                    </b-col>
                    <b-col lg="4">
                        <MitgliederFunctions />
                    </b-col>
                </b-row>
            </b-collapse>

            <MitgliederList :selectedFields="fieldsObj" :filter="filterObj" />
        </div>
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import MainContainer from "@/components/MainContainer/MainContainer";
import MitgliederFilter from "@/components/MitgliederFilter/MitgliederFilter";
import MitgliederFunctions from "@/components/MitgliederFunctions/MitgliederFunctions";
import MitgliederList from "@/components/MitgliederList/MitgliederList";

export default {
    name: "mitglieder",
    data() {
        return {
            fieldsObj: null,
            filterObj: null
        };
    },
    components: {
        MainContainer,
        MitgliederFilter,
        MitgliederFunctions,
        MitgliederList
    },
    computed: {
        toggleBtnText() {
            return this.filterShown
                ? "Filter und Funktionen ausblenden"
                : "Filter und Funktionen anzeigen";
        },
        filterShown: {
            get: function() {
                const pages = this.$store.getters.getPages;
                if (pages.mitglieder) {
                    return pages.mitglieder.filterShown;
                }
                return true;
            },
            set: function(val) {
                this.$store.dispatch("pages", {
                    mitglieder: {
                        filterShown: val
                    }
                });
            }
        }
    },
    methods: {
        submitFilter(payload) {
            this.fieldsObj = payload.fields;
            this.filterObj = payload.filter;
        }
    }
};
</script>
